import{a as e}from"./chunk-XICVBFHQ.js";import{m as r}from"./chunk-HBP5N4FR.js";r();function d(o){return e()===o}export{d as a};
//# sourceMappingURL=chunk-3WDAQKEN.js.map
